import {styled} from "@material-ui/core/styles";
import {Button, Dropdown} from "react-bootstrap";
import styles from "./_export.modules.scss";

const buttonStyle = styled(Button)({
    height: "40px",
    lineHeight: "18px",
    fontSize: "16px",
    fontFamily: styles.regularFontStyle,
    textTransform: "none",
    letterSpacing: "-0.08px",
});

export const YellowButton = styled(buttonStyle)({
    background: styles.colorOrange,
    color: styles.colorWhite,
    borderColor: styles.colorOrange,
    borderRadius: "12px",
    marginRight: "16px",
    "&:focus": { background: styles.colorOrange, borderColor: styles.colorOrange },
    "&:hover": {
        background: styles.colorDarkOrange,
        borderColor: styles.colorOrange,
    },
    "&:disabled": {
        background: styles.disabledColor,
        borderColor: styles.disabledColor,
    },
});

export const RedButton = styled(buttonStyle)({
    background: styles.colorRed,
    color: styles.colorWhite,
    borderColor: styles.colorRed,
    "&:focus": { background: styles.colorDarkRed, borderColor: styles.colorDarkRed },
    "&:hover": {
        background: styles.colorDarkRed,
        borderColor: styles.colorDarkRed,
    },
});

export const GreenButton = styled(buttonStyle)({
    background: styles.colorGreen,
    color: styles.colorWhite,
    borderColor: styles.colorGreen,
    "&:focus": { background: styles.colorDarkGreen, borderColor: styles.colorDarkGreen },
    "&:hover": {
        background: styles.colorDarkGreen,
        borderColor: styles.colorDarkGreen,
    },
});

export const StyledBlueButton = styled(buttonStyle)({
    background: styles.colorDarkBlue,
    color: styles.colorWhite,
    borderColor: styles.colorDarkBlue,
    marginLeft: "10px",
    marginRight: "10px",
    "&:focus": { background: styles.colorDarkBlue, color: styles.colorWhite, borderColor: styles.colorDarkBlue, },
    "&:hover": {
        color: styles.colorWhite,
        background: styles.colorLightBlue,
        borderColor: styles.colorLightBlue,
    },
    "&:disabled": {
        background: styles.disabledColor,
        borderColor: styles.disabledColor,
    },
});

export const StyledBlackButton = styled(buttonStyle)({
    background: styles.colorLightBlack,
    color: styles.colorWhite,
    borderColor: styles.colorLightBlack,
    marginLeft: "10px",
    "&:focus": { background: styles.colorLightBlack, color: styles.colorWhite, borderColor: styles.colorLightBlack},
    "&:hover": {
        color: styles.colorWhite,
        background: styles.colorLighterBlack,
        borderColor: styles.colorLighterBlack,
    },
    "&:disabled": {
        background: styles.disabledColor,
        borderColor: styles.disabledColor,
    },
});

export const StyledDarkBlueButton = styled(buttonStyle) ({
    background: styles.colorDarkerBlue,
    color: styles.colorWhite,
    borderColor: styles.colorDarkerBlue,
    marginLeft: "10px",
    "&:focus": {
        background: styles.colorDarkBlue,
        color: styles.colorWhite,
        borderColor: styles.colorDarkBlue},
    "&:hover": {
        color: styles.colorWhite,
        background: styles.colorDarkBlue,
        borderColor: styles.colorDarkBlue,
    },
    "&:disabled": {
        background: styles.disabledColor,
        borderColor: styles.disabledColor,
    },
});

export const DropDownToggle = styled(Dropdown.Toggle)({
    fontSize: "14px",
    color: "#2c82be",
    "&:hover": {
        color: "#425B8D",
        textDecoration: "underline",
    },
    "&:after": {
        display: "none",
    },
});